import { useState, useEffect, useRef, ReactNode } from 'react';
import clsx from 'clsx';

interface TooltipCellProps {
  className?: string;
  children: ReactNode;
}

export const TooltipCell = (props: TooltipCellProps) => {
  const [title, setTitle] = useState<string>('');
  const nodeValue = useRef<HTMLDivElement>(null);
  const nodeTooltip = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    return () => {
      if (nodeTooltip.current) {
        nodeTooltip.current.remove();
        nodeTooltip.current = null;
      }
    };
  }, []);

  const handleMouseEnter = () => {
    if (!nodeValue.current) return;
    const { scrollWidth, offsetWidth } = nodeValue.current;
    if (scrollWidth <= offsetWidth) return;
    showToolTip();
  };
  const showToolTip = () => setTitle(nodeValue.current?.innerText || '');

  return (
    <div className={clsx('relative w-full', props.className)}>
      <div ref={nodeValue} className='overflow-hidden relative text-ellipsis w-full' onMouseEnter={handleMouseEnter} title={title}>
        {props.children}
      </div>
    </div>
  );
};
